import script from "./PosCloseSessionDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./PosCloseSessionDialog.vue?vue&type=script&setup=true&lang=js"

import "./PosCloseSessionDialog.vue?vue&type=style&index=0&id=8e105930&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e105930"]])

export default __exports__